import type { RegisteredTenant } from '@festina/life-general-types/life'
import { useAuthenticationContext } from '@festina-life/authentication'
import type {
  Optional,
  ServerWithTestWithoutReplicators,
} from '@festina-life/core'

export const useIsComponentAvailable = ({
  component,
  availableTenants,
  forTenantId,
}: {
  component: ServerWithTestWithoutReplicators
  availableTenants: RegisteredTenant[]
  forTenantId?: Optional<string>
}) => {
  const { environmentSettings } = useAuthenticationContext()
  const upperCaseComponent =
    component.toUpperCase() as Uppercase<ServerWithTestWithoutReplicators>
  const isComponentAvailable =
    !!environmentSettings?.[`REACT_APP_${upperCaseComponent}_API_ENDPOINT`]

  return forTenantId
    ? isComponentAvailable &&
        availableTenants?.some((tenant) => tenant?.tenantId === forTenantId)
    : isComponentAvailable
}
